import React, { ChangeEvent, useEffect } from "react";
import { useSelector } from "react-redux";
import { getInfoRemitentes } from "../../../../redux/actions/actionsCrear";
import { RootState, useAppDispatch } from "../../../../redux/store";
import "../../../../styles/formularioremitente.css";
import { ChildProps_logistica_GUIA_PROFORMAviewModel } from "../ContentGuia";
import { StylePropsSelect } from "../styles";
import { StyleProps1, StyleProps2, StyleProps3 } from "./styles";




const FormularioRemitente: React.FC<ChildProps_logistica_GUIA_PROFORMAviewModel> = ({vm, guia, setGuia}) => {
  const dispatch = useAppDispatch()
  const remitentesStore = useSelector((state: RootState) => state.crear.remitente);
  const usuarioVM = useSelector((state: RootState) => state.auth.usuarioActual);

  useEffect(() => {
      dispatch(getInfoRemitentes(usuarioVM._ItemActivo.id)) 
  },[])

  useEffect(() => {
    if(remitentesStore.info.length && vm._ItemActivo.idRemitente){
      vm.EstablecerClienteRemitente(remitentesStore.info, guia.idRemitente, guia, setGuia)
    }
  },[remitentesStore.loading])

const handleRemitente = (e: ChangeEvent<HTMLSelectElement>) => {
    const idCliente = Number(e.target.value) 
    const idCiudadOrigenPredefinida = usuarioVM._ItemActivo.idCiudad
    if(idCliente){
      vm.EstablecerClienteRemitente(remitentesStore.info, idCliente, guia, setGuia, idCiudadOrigenPredefinida)
    }
  } 

  return (
    <div className="col-xl-6 invoice-address-company">
      <h4 style={StyleProps3}>Remitente:</h4>
      <div className="invoice-address-company-fields">
        <div className="form-group row">
          <label
            htmlFor="name"
            className="col-sm-2 col-form-label"
            style={StyleProps2}
            >
            Nombre:
          </label>
          <div className="col-sm-10">
          <select name="country_code"
              onChange={(e) => handleRemitente(e)}
              className="form-control country_code"
              style={StylePropsSelect}
              color="white" id="payment-method-country"
              value={guia.idRemitente || "none"}
          >
            <option hidden value="none">Escoja un Remitente</option>
              {remitentesStore.loading ===false ?
              remitentesStore.info.map(remitente => 
                <option value={remitente.idCliente} key ={remitente.idCliente}>{remitente.CLIENTE?.razonSocial}</option>
              )
              :<>
              </>
              }
           </select>
           </div>
         </div>
         <div className="form-group row">
           <label
             htmlFor="name"
             className="col-sm-2 col-form-label"
             style={StyleProps2}
           >
             Cédula:
           </label>
           <div className="col-sm-10">
             <input
               type="id"
               readOnly
               className="form-control-plaintext"
               style={StyleProps1}
               onChange={() => {}}
               value={guia.CLIENTE_REMITENTE?.cedula || "Seleccione un remitente"}
             />
           </div>
         </div>
         <div className="form-group row">
           <label
             htmlFor="name"
             className="col-sm-2 col-form-label"
             style={StyleProps2}
           >
             Dirección:
           </label>
           <div className="col-sm-10">
             <input
               type="adress"
               readOnly
               className="form-control-plaintext"
               style={StyleProps1}
               onChange={() => {}}
               value={guia.CLIENTE_REMITENTE?.direccion || "Seleccione un remitente"}
             />
           </div>
         </div>
         <div className="form-group row">
           <label
             htmlFor="name"
             className="col-sm-2 col-form-label"
             style={StyleProps2}
           >
             Teléfono:
           </label>
           <div className="col-sm-10">
             <input
               type="phone"
               readOnly
               className="form-control-plaintext"
               style={StyleProps1}
               value={guia.CLIENTE_REMITENTE?.telefono || "Seleccione un remitente"}
               onChange={() => {}}
             />
           </div>
           </div>
          <div className="form-group row">
           <label
             htmlFor="name"
             className="col-sm-2 col-form-label"
             style={StyleProps2}
           >
             E-mail:
           </label>
           <div className="col-sm-10">
             <input
               type="email"
               readOnly
               className="form-control-plaintext"
               style={StyleProps1}
               onChange={() => {}}
               value={guia.CLIENTE_REMITENTE?.email || "Seleccione un remitente"}
             />
           </div>
         </div>

         <div className="form-group row">
           <label
             htmlFor="name"
             className="col-sm-2 col-form-label"
             style={StyleProps2}
           >
             Celular:
           </label>
           <div className="col-sm-10">
             <input
               readOnly
               className="form-control-plaintext"
               style={StyleProps1}
               value={guia.CLIENTE_REMITENTE?.celular||""}
               onChange={() => {}}
             />
           </div>
         </div>
       </div>
     </div>
  );
};

export default FormularioRemitente;
